<template>
  <b-modal
    v-model="modalShow"
    size="sm"
    centered
    title="Print RackGroup Stock Reports"
    @hidden="$emit('modal-closed')"
  >
    <div>
      <b-form @submit.prevent="submitHandler">
        <b-form-group
          label="User"
        >
          <custom-v-select
            v-model="selectedUserId"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="operationUsers"
            label="name"
            placeholder="Select User"
            :reduce="(item) => item.id"
          />
        </b-form-group>
      </b-form>
    </div>

    <template #modal-footer="{ cancel }">
      <b-button
        variant="secondary"
        @click="cancel()"
      >
        Cancel
      </b-button>
      <b-button
        variant="primary"
        :disabled="!selectedUserId || isDownloading"
        @click="submitHandler"
      >
        Print
        <b-spinner
          v-if="isDownloading"
          small
          label="Small Spinner"
        />
      </b-button>

    </template>
  </b-modal>
</template>

<script>
import {
  BButton,
  BSpinner,
  BForm,
  BFormGroup,
} from 'bootstrap-vue'
import axios from 'axios'
import CustomVSelect from '@/components/UI/CustomVSelect.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BButton,
    BSpinner,
    BFormGroup,
    BForm,
    CustomVSelect,
  },
  props: {
    operationUsers: {
      type: Array,
      required: true,
    },
    reportIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      modalShow: true,
      submitting: false,
      selectedUserId: null,
      isDownloading: false,
    }
  },
  methods: {
    async submitHandler() {
      try {
        const payload = { ids: this.reportIds, operation_user_id: this.selectedUserId }

        this.isDownloading = true
        const response = await axios.post('/stocks/download_rg_stock_reports/', payload, {
          responseType: 'blob',
        })

        this.printPDF(response.data)

        // Close model after 1 Sec
        setTimeout(() => {
          this.modalShow = false
          this.$emit('downloaded')
          this.isDownloading = false
        }, 1000)
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.detail || 'Failed to download!',
            icon: 'CheckIcon',
            variant: 'danger',
          },
        })
        this.isDownloading = false
      }
    },
    printPDF(blob) {
      const pdfBlob = (blob instanceof Blob) ? blob : new Blob([blob], { type: 'application/pdf' })
      const blobUrl = URL.createObjectURL(pdfBlob)

      const iframe = document.createElement('iframe')

      // Keep it off-screen but give it dimensions so Edge renders it
      Object.assign(iframe.style, {
        position: 'absolute',
        top: '-10000px',
        width: '1000px',
        height: '1000px',
      })

      iframe.src = blobUrl
      document.body.appendChild(iframe)

      iframe.onload = () => {
        // Give the PDF viewer a moment to parse the file
        setTimeout(() => {
          try {
            iframe.contentWindow.focus()
            iframe.contentWindow.print()
          } catch (e) {
            // console.error('Print error:', e)
          }
        }, 300)
      }
    },

  },
}
</script>
